"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = parse;
exports.toCSSValue = toCSSValue;
const shared_utils_1 = require('../utils/shared-utils.cjs');
const css_variable_1 = require('./css-variable.cjs');
const types_1 = require('../types.cjs');
/**
 * Parses CSS object-fit property values
 *
 * Syntax: fill | contain | cover | none | scale-down | inherit | initial | unset | revert
 *
 * @param value - The CSS object-fit value to parse
 * @returns Parsed ObjectFitValue or null if invalid
 *
 * @example
 * ```typescript
 * parse('fill') // { type: 'keyword', keyword: 'fill' }
 * parse('contain') // { type: 'keyword', keyword: 'contain' }
 * parse('cover') // { type: 'keyword', keyword: 'cover' }
 * parse('none') // { type: 'keyword', keyword: 'none' }
 * parse('scale-down') // { type: 'keyword', keyword: 'scale-down' }
 * parse('inherit') // { type: 'keyword', keyword: 'inherit' }
 * parse('var(--my-fit)') // { type: 'variable', variable: 'my-fit' }
 * ```
 */
function parse(value) {
    if (!value || typeof value !== 'string') {
        return null;
    }
    const trimmed = value.trim();
    if (trimmed === '') {
        return null;
    }
    // CSS variables - parse and return directly
    if ((0, shared_utils_1.isCssVariable)(trimmed)) {
        return (0, css_variable_1.parse)(trimmed);
    }
    // Handle global keywords
    if ((0, shared_utils_1.isGlobalKeyword)(trimmed)) {
        return {
            type: 'keyword',
            keyword: trimmed.toLowerCase()
        };
    }
    // Handle object-fit specific keywords
    const keywordResult = (0, shared_utils_1.getValidKeyword)(trimmed.toLowerCase(), types_1.OBJECT_FIT_KEYWORDS);
    if (keywordResult) {
        return {
            type: 'keyword',
            keyword: keywordResult
        };
    }
    return null;
}
/**
 * Converts a parsed ObjectFitValue back to its CSS string representation
 *
 * @param value - The parsed object-fit value
 * @returns CSS string representation or null if invalid
 */
function toCSSValue(value) {
    if (!value) {
        return null;
    }
    // Handle CSS variables
    if (value.type === 'variable') {
        return (0, css_variable_1.toCSSValue)(value);
    }
    // Handle keyword values (both object-fit-specific and global)
    if (value.type === 'keyword') {
        return value.keyword;
    }
    return null;
}
